import { useGetAllMerchants } from "../../../hooks/queries/useMerchantQueries";

export const useMerchantData = (filters) => {
  const { data, isLoading, isFetching, isError, error, refetch } =
    useGetAllMerchants(filters);

  return {
    merchants: data?.content ?? [],
    totalPages: data?.totalPages ?? 0,
    totalElements: data?.totalElements ?? 0,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
};

export default useMerchantData;
